import { action, extendObservable } from 'mobx';
import FetchService from '../../../core/services/FetchService';
import FormService from '../../../core/services/FormService';
import NotificationService from '../../../core/services/NotificationService';
import { isRequired } from '../../../core/validations';
import { browserHistory } from 'react-router';
import EmailTemplateUploadFormService from './EmailTemplateUploadFormService';
import ConfirmationDialogService from '../../../core/services/ConfirmationDialogService';

class EmailTemplateFormService {
  form = new FormService();
  fetch = new FetchService();
  submit = new FetchService();

  constructor() {
    extendObservable(this, {
      emailTemplateId: null,
    });
    this.form.validations = {
      type: [isRequired],
      key: [isRequired],
    };
    this.form.reset();
    this.form.setInitialValues({});
  }

  handleLoad = action(async (emailTemplateId) => {
    this.form.reset();
    this.form.setInitialValues({ templates: [] });
    this.emailTemplateId = emailTemplateId;

    if (emailTemplateId) {
      await this.fetch.fetch({ url: `/email-templates/${emailTemplateId}` });
      if (this.fetch.data) {
        this.form.setInitialValues(this.fetch.data);
      }
    }
  });

  handleSubmit = action(() => {
    this.form.submitted = true;
    if (this.form.errors) {
      NotificationService.addNotification('Fill the required fields', 'error');
      return;
    }

    const formData = new FormData();
    this.form
      .getValue('templates')
      .map((template) => formData.append(`template-${template.locale}`, template.template));
    formData.append(
      'templates',
      JSON.stringify(
        this.form.getValue('templates').map((template) => ({
          locale: template.locale,
          subject: template.subject,
          template: typeof template.template === 'string' ? template.template : '',
        }))
      )
    );
    formData.append('key', this.form.getValue('key'));
    formData.append('type', this.form.getValue('type'));

    this.submit
      .fetch({
        method: this.emailTemplateId ? 'put' : 'post',
        url: this.emailTemplateId ? `/email-templates/${this.emailTemplateId}` : `/email-templates`,
        body: formData,
      })
      .then(() => {
        if (this.submit.data) {
          browserHistory.push('/email-templates');
          NotificationService.addNotification(
            `Email Template ${this.emailTemplateId ? 'updated' : 'created'} successfully.`,
            'success'
          );
        }
        if (this.submit.error) {
          NotificationService.addNotification(
            `Error ${this.emailTemplateId ? 'updating' : 'creating'} Email Template.`,
            'error'
          );
        }
      });
  });

  handleEdit = (locale) => {
    EmailTemplateUploadFormService.form.reset();
    EmailTemplateUploadFormService.form.setInitialValues(
      this.form.getValue('templates').find((template) => template.locale === locale)
    );
  };

  handleDelete = (locale) => {
    ConfirmationDialogService.show(
      'Delete Email Template',
      `You are about to delete the "${locale}" Email Template, are you sure?`,
      () => {
        this.form.setValue('templates', [
          ...this.form.getValue('templates').filter((template) => template.locale !== locale),
        ]);
      }
    );
  };

  handleTemplateDownload = (filePath) => {
    const link = document.createElement('a');
    link.href = `${process.env.REACT_APP_FILES_URL}/${filePath}`;

    link.download = filePath.split('/').pop();
    link.click();
    setTimeout(() => window.URL.revokeObjectURL(filePath, 500));
  };
}

const emailTemplateFormService = new EmailTemplateFormService();
export default emailTemplateFormService;
